import { useLanguage } from "../context/LanguageContext";
import { Badge } from "./ui/badge";

const SkillsSection = ({ skills }) => {
  const { language, t } = useLanguage();

  const getLocalizedText = (field) => {
    if (typeof field === 'string') return field;
    return language === 'no' ? field.no : field.en;
  };

  return (
    <section data-testid="skills-section" className="py-16 md:py-24 border-t border-slate-200">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-800 mb-12 animate-fade-in-up">
        {t('Tekniske Ferdigheter', 'Technical Skills')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {skills.categories.map((category, index) => (
          <div
            key={index}
            data-testid={`skill-category-${index}`}
            className="animate-fade-in-up"
            style={{ animationDelay: `${(index + 1) * 100}ms` }}
          >
            <h3 className="text-lg font-semibold text-slate-900 mb-4">
              {category.title}
            </h3>
            <div className="flex flex-wrap gap-2">
              {category.items.map((skill, skillIndex) => (
                <Badge
                  key={skillIndex}
                  variant="secondary"
                  className="bg-slate-100 text-slate-700 hover:bg-sky-100 hover:text-sky-700 transition-colors duration-300 px-3 py-1"
                >
                  {getLocalizedText(skill)}
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SkillsSection;
